import { observer } from 'mobx-react';
import * as React from 'react';
import GroupsStore from '../../../../GroupsStore';
import {
  Ready,
  Sorting,
  UpdatingQuery,
  UpdatingSearchParameters,
} from '../../../../GroupsStore/Types';
import GenericSortFilter from '../../../GenericSortFilter';
import OrganizationFilter from '../../Filters/OrganizationFilter';
import Search from '../../Filters/Search';

interface Props {
  store: GroupsStore;
  groupsStoreState: Ready | UpdatingQuery | UpdatingSearchParameters | Sorting;
}

const Filters: React.FC<Props> = ({ store, groupsStoreState }) => {
  switch (store.optionsStore.state.kind) {
    case 'error':
    case 'loading':
    case 'waiting':
      return <></>;
    case 'ready':
      const { payload } = store.optionsStore.state.resource;
      return (
        <div className="flex flex-col py-5 md:flex-row ">
          <Search store={store} label="Search Participant Name" />
          <OrganizationFilter
            className="mr-4 w-1/4"
            updatingOrganizationParameters={store.updatingOrganizationParameters}
            selectedOrganization={groupsStoreState.selectedOrganization}
          />
          <div className="mr-4 w-1/4">
            <GenericSortFilter
              labelText="Last Login"
              options={payload.loginActivities}
              parameters={store.searchParameters}
              updatingParameters={store.updatingSearchParameters}
              sortFilterKey={'last_sign_in_at'}
            />
          </div>
          <div className="mr-4 w-1/4">
            <GenericSortFilter
              labelText="Status"
              options={payload.status}
              parameters={store.searchParameters}
              updatingParameters={store.updatingSearchParameters}
              sortFilterKey={'status'}
            />
          </div>
        </div>
      );
  }
};

export default observer(Filters);
